import styled, { css } from "styled-components"

interface CardProps {
  readonly margin?: string
  readonly overflowY?: string
  readonly overflowX?: string
  readonly width?: string
}

export const Card = styled.div<CardProps>`
  background-color: ${props => (props.color && props.color) || "#fff"};
  background-clip: border-box;
  border: none;
  border-radius: 0.625rem;
  box-shadow:
    0 1px 2px 0 rgba(60, 64, 67, 0.3),
    0 1px 3px 1px rgba(60, 64, 67, 0.15);
  display: flex;
  flex-direction: column;
  margin: ${props => (props.margin && props.margin) || "0"};
  min-width: 0;
  overflow-y: ${props => props.overflowY || "hidden"};
  overflow-x: ${props => props.overflowX || "auto"};
  position: relative;
  word-wrap: break-word;
  width: ${props => props.width || "auto"};
`

interface CardHeaderProps {
  readonly noHeader?: boolean
  readonly block?: boolean
  readonly justifyContent: string
}

export const CardHeader = styled.div<CardHeaderProps>`
  border-bottom: ${props => (props.noHeader && "0") || "1px"} solid ${props => props.theme.grey};
  padding: 1rem;
  display: ${props => (props.block && "block") || "flex"};
  align-items: center;
  justify-content: ${props => props.justifyContent};
  width: 100%;
`

interface CardBodyProps {
  readonly flex?: boolean
  readonly padding?: string
  readonly center?: boolean
  readonly justifyContent?: string
  readonly justifyCenter?: boolean
  readonly justifyAround?: boolean
  readonly justifyBetween?: boolean
  readonly justifyEnd?: boolean
  readonly alignItems?: string
  readonly alignStretch?: boolean
  readonly alignBaseline?: boolean
  readonly alignEnd?: boolean
  readonly alignCenter?: boolean
  readonly alignContent?: boolean
  readonly content?: string
  readonly contentStart?: boolean
  readonly contentEnd?: boolean
  readonly contentCenter?: boolean
  readonly contentBetween?: boolean
  readonly contentAround?: boolean
}

export const CardBody = styled.div<CardBodyProps>`
  padding: ${props => props.padding || "1rem"};
  text-align: ${props => props.center && "center"};
  display: ${props => props.flex && "flex"};
  flex-wrap: wrap;
  justify-content: ${props => {
    return (
      (props.justifyContent && props.justifyContent) ||
      (props.justifyCenter && "center") ||
      (props.justifyAround && "space-around") ||
      (props.justifyBetween && "space-between") ||
      (props.justifyEnd && "flex-end") ||
      "flex-start"
    )
  }};

  align-items: ${props => {
    return (
      (props.alignItems && props.alignItems) ||
      (props.alignStretch && "stretch") ||
      (props.alignEnd && "flex-end") ||
      (props.alignCenter && "center") ||
      (props.alignBaseline && "baseline") ||
      "flex-start"
    )
  }};
  align-content: ${props => {
    return (
      (props.alignContent && props.content) ||
      (props.contentStart && "flex-start") ||
      (props.contentEnd && "flex-end") ||
      (props.contentCenter && "center") ||
      (props.contentBetween && "space-between") ||
      (props.contentAround && "space-around") ||
      "stretch"
    )
  }};
`

export const CardTitle = styled.span`
  display: block;
  font-size: 1.5rem;
  margin: 0 1em 0 0;
`

interface SectionProps {
  readonly padding?: string
  readonly noPadding?: boolean
  readonly noBorder?: boolean
}

export const Section = styled.div<SectionProps>`
  padding: ${props => props.padding || (props.noPadding && "0") || "1rem"};
  border-bottom: 1px solid ${props => props.theme.grey};
  margin: 0 0 1rem 0;

  ${props =>
    props.noBorder &&
    css`
      border: none;
    `}
`

export const SectionTitle = styled.span`
  display: block;
  color: ${props => props.theme.basegrey};
  font-size: 1.2em;
  margin: 0 0 1rem 0;
`
